export default __webpack_public_path__ + "static/media/streak-tier-1.1f8d268c.png";